<template>
  <div class="pupils-lesson m-t-6">
    <!-- <button
      @click="openObject('item_pupils')"
      class="btn-edit"
    >
      <svg class="svg-pencil" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none"><path opacity="0.983" fill-rule="evenodd" clip-rule="evenodd" d="M18.7549 -0.0224609C18.9795 -0.0224609 19.2041 -0.0224609 19.4287 -0.0224609C19.9695 0.0756857 20.4487 0.307782 20.8662 0.673828C21.4291 1.22168 21.9756 1.7832 22.5059 2.3584C22.7289 2.67693 22.8861 3.02134 22.9775 3.3916C22.9775 3.72103 22.9775 4.05046 22.9775 4.37988C22.8675 4.76477 22.6953 5.12415 22.4609 5.45801C21.8164 6.11 21.1651 6.75387 20.5068 7.38965C18.8593 5.71968 17.2121 4.06505 15.5654 2.42578C16.2093 1.7819 16.8532 1.13802 17.4971 0.494141C17.8788 0.219935 18.2981 0.0477344 18.7549 -0.0224609Z" fill="#8B77F1"/><path opacity="0.99" fill-rule="evenodd" clip-rule="evenodd" d="M0.741211 22.9775C0.576496 22.9775 0.411784 22.9775 0.24707 22.9775C0.142253 22.9027 0.052409 22.8128 -0.0224609 22.708C-0.0224609 22.5433 -0.0224609 22.3786 -0.0224609 22.2139C0.463046 20.3319 0.949698 18.4451 1.4375 16.5537C5.66766 12.3236 9.89777 8.09344 14.1279 3.86328C14.1729 3.83333 14.2178 3.83333 14.2627 3.86328C15.8724 5.47297 17.4821 7.0827 19.0918 8.69238C19.1218 8.73731 19.1218 8.78223 19.0918 8.82715C14.8616 13.0573 10.6315 17.2874 6.40137 21.5176C4.50993 22.0054 2.62319 22.492 0.741211 22.9775Z" fill="#8B77F1"/></svg>
    </button> -->
    <div class="pupils-lesson-items">
      <figure 
        v-for="journal in journals" :key="journal.id"
        :style="`--color-card: ${journal.color}`"
        @click="openObject(journal, 'pupils', 'item_')"
      >
      
        <div class="item-shell">
          <div class="img-content">
            <img :src="journal.icon">
          </div>
          <div class="desc-content">
            {{ journal.title }}
          </div>
        </div>
      </figure>
    </div>
  </div>
</template>
<script>
import {getJournal} from '@/_api/apiPupil';
export default {
  components: {
    "Timtables": () => import("@/components/Pupils/Journal/Timetables"),
  },
  props: {
    group_id: {
      default:null
    }
  },
  created(){
      this.getJournal(this.group_id);
  },
  methods: {
    getJournal:getJournal,
    openObject(item, card, prefix = "") {
      const element = `${prefix}${card}`;

      let link = item.id;

      let query = Object.assign({}, this.$route.query);
      if (query[element] == link) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = link;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  data() {
    return {
       journals:[],
    };
  },
};
</script>

